// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}
.page-header .back-arrow {
  margin-right: 1rem;
}
.page-header .back-arrow a {
  color: #007bff;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
}
.page-header .back-arrow a:hover {
  text-decoration: underline;
}
.page-header .back-arrow a i {
  font-size: 1.2rem;
}
.page-header h1 {
  flex: 1;
  text-align: center;
  margin: 0;
  font-size: 1.8rem;
  color: #333;
}

.content-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1rem;
}

.details-content .details-header {
  margin-bottom: 1.5rem;
}
.details-content .details-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
}
.details-content .details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}
.details-content .detail-item label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
  color: #555;
}
.details-content .detail-item p {
  margin: 0;
  color: #666;
  line-height: 1.5;
}

.attachments-section {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}
.attachments-section h3 {
  margin-bottom: 1rem;
  color: #333;
}
.attachments-section .attachments-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.attachments-section .file-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fafafa;
  cursor: pointer;
  transition: background 0.15s;
}
.attachments-section .file-item:hover {
  background: #f0f4ff;
  border-color: #b0c4ff;
}
.attachments-section .file-item .file-icon {
  font-size: 1.2rem;
  color: #555;
  flex-shrink: 0;
}
.attachments-section .file-item .file-name {
  flex: 1;
  font-size: 0.9rem;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.attachments-section .file-item .file-download-icon {
  font-size: 0.9rem;
  color: #888;
  flex-shrink: 0;
}

.text-center {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/argic/view/my-change-requests/my-change-requests.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACI,kBAAA;AACR;AAAQ;EACI,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAEZ;AAAY;EACI,0BAAA;AAEhB;AACY;EACI,iBAAA;AAChB;AAII;EACI,OAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;AAFR;;AAMA;EACI,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;AAHJ;;AAOI;EACI,qBAAA;AAJR;AAMQ;EACI,SAAA;EACA,WAAA;EACA,iBAAA;AAJZ;AAQI;EACI,aAAA;EACA,2DAAA;EACA,WAAA;EACA,mBAAA;AANR;AAUQ;EACI,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;AARZ;AAUQ;EACI,SAAA;EACA,WAAA;EACA,gBAAA;AARZ;;AAaA;EACI,gBAAA;EACA,mBAAA;EACA,0BAAA;AAVJ;AAYI;EACI,mBAAA;EACA,WAAA;AAVR;AAaI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAXR;AAcI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AAZR;AAcQ;EACI,mBAAA;EACA,qBAAA;AAZZ;AAeQ;EACI,iBAAA;EACA,WAAA;EACA,cAAA;AAbZ;AAgBQ;EACI,OAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAdZ;AAiBQ;EACI,iBAAA;EACA,WAAA;EACA,cAAA;AAfZ;;AAoBA;EACI,kBAAA;AAjBJ","sourcesContent":[".page-container {\n    padding: 2rem;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n.page-header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 2rem;\n    \n    .back-arrow {\n        margin-right: 1rem;\n        a {\n            color: #007bff;\n            text-decoration: none;\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n            font-size: 1rem;\n            \n            &:hover {\n                text-decoration: underline;\n            }\n            \n            i {\n                font-size: 1.2rem;\n            }\n        }\n    }\n    \n    h1 {\n        flex: 1;\n        text-align: center;\n        margin: 0;\n        font-size: 1.8rem;\n        color: #333;\n    }\n}\n\n.content-container {\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    padding: 1rem;\n}\n\n.details-content {\n    .details-header {\n        margin-bottom: 1.5rem;\n        \n        h2 {\n            margin: 0;\n            color: #333;\n            font-size: 1.5rem;\n        }\n    }\n    \n    .details-grid {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n        gap: 1.5rem;\n        margin-bottom: 2rem;\n    }\n    \n    .detail-item {\n        label {\n            font-weight: bold;\n            display: block;\n            margin-bottom: 0.5rem;\n            color: #555;\n        }\n        p {\n            margin: 0;\n            color: #666;\n            line-height: 1.5;\n        }\n    }\n}\n\n.attachments-section {\n    margin-top: 2rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid #eee;\n    \n    h3 {\n        margin-bottom: 1rem;\n        color: #333;\n    }\n    \n    .attachments-list {\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n    }\n    \n    .file-item {\n        display: flex;\n        align-items: center;\n        gap: 0.75rem;\n        padding: 0.6rem 0.75rem;\n        border: 1px solid #e0e0e0;\n        border-radius: 6px;\n        background: #fafafa;\n        cursor: pointer;\n        transition: background 0.15s;\n        \n        &:hover {\n            background: #f0f4ff;\n            border-color: #b0c4ff;\n        }\n        \n        .file-icon {\n            font-size: 1.2rem;\n            color: #555;\n            flex-shrink: 0;\n        }\n        \n        .file-name {\n            flex: 1;\n            font-size: 0.9rem;\n            color: #333;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n        }\n        \n        .file-download-icon {\n            font-size: 0.9rem;\n            color: #888;\n            flex-shrink: 0;\n        }\n    }\n}\n\n.text-center {\n    text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
